<app-modal-container
  data-qa="kpi-portfolio-analysis-crud-modal"
  [bigSize]="false"
  [titleDirection]="'start'"
  [title]="'Settings'"
  [buttons]="{ close: true }"
  [spinnerProps]="spinnerProps"
  (closeButtonClicked)="close(false)">
  <ng-container *ngVar="!formGroup || !metricsForSelector || !companiesForSelector as showSkeleton">
    <div class="vertical-container-simple column-gap-2 w-[43.4375rem]">
      <div class="overlap-children w-full flex">
        <!--Skeleton-->
        <div *ngIf="showSkeleton"
             @fadeInOut
             class="flex-grow-1 w-full">
          <div class="centered-column-container width-100pcnt column-gap-1">
            <div class="centered-column-container width-100pcnt column-gap-1">
              <div class="start-start-row-container row-gap-0p78125">
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 w-[25.625rem] height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-10 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
              </div>
              <div class="start-start-row-container row-gap-0p78125">
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 w-[25.625rem] height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-10 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
              </div>
              <div class="start-start-row-container row-gap-0p78125">
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 w-[25.625rem] height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-10 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
                <div class="bg-black-3 width-1p5 height-2p625 br-0p5"></div>
              </div>
            </div>
            <div class="width-90pcnt bg-black-3 height-2p5 br-0p5"></div>
          </div>
        </div>
        <!--Real data-->
        <div
          *ngIf="!showSkeleton"
          @fadeInOut
          class="vertical-container gap-[1rem] w-full"
          data-qa="kpi-portfolio-analysis-crud-modal-form-group"
          [formGroup]="formGroup.crossCompanyAnalysisForm">
          <app-checkbox-selector
            data-qa="companies-selector"
            [items]="companiesForSelector"
            [props]="{ title: 'Selected companies', isSelectAllEnabled: true }"
            [customText]="selectedCompanies.length === 1 ? selectedCompanies[0].item : selectedCompanies.length + ' companies'"
            (itemEmitter)="updateSelectedCompanies($event)"
          />
          <div class="w-full border-bottom"></div>
          @if (formGroup.metrics.controls.length) {
            <div
              cdkDropList
              data-qa="kpi-cross-company-crud-modal-form-group-bundles"
              formArrayName="metrics"
              class="flex flex-col items-start justify-start w-full gap-[1rem]"
              (cdkDropListDropped)="formGroup.drop($event)">
              <div class="bold600">Metrics</div>
              <div *ngFor="let metric of formGroup.metrics.controls, let i = index"
                   cdkDrag
                   cdkDragPreviewClass="cdk-drag-preview"
                   [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i"
                   class="start-start-row-container row-gap-0p78125 w-full"
                   [formGroupName]="i"
                   [cdkDragData]="metric">
                <app-all-icons
                  cdkDragHandle
                  class="icon-size-1p5 pd-top-0p6 centered-row-container"
                  [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i+'-icon'"
                  [style.cursor]="'pointer'"
                  [iconNameAndStyling]="'two-lines-six-dots.svg'">
                </app-all-icons>
                <app-selector-autocomplete-deferred
                  [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i+'-metric'"
                  class="w-[25.625rem]"
                  [data]="metricsForSelector"
                  [selectedItem]="metric.value.metricUUID ? metric.value.groupName + ' • ' + metric.value.name : null"
                  [isInsideModal]="true"
                  [onLoadAction]="getAmountOfCompaniesWithData"
                  (valueEmitter)="formGroup.setMetric(i, $event)">
                </app-selector-autocomplete-deferred>
                <app-selector
                  [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i+'-role'"
                  formControlName="role"
                  class="w-[10rem]"
                  [data]="metricDataRolesForSelector"
                  [isNotInTable]="true"
                  [selectedItem]="metric.value.role">
                </app-selector>
                <app-all-icons
                  [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i+'-delete-metric'"
                  class="icon-size-1p5 pd-top-0p6"
                  [style.cursor]="'pointer'"
                  [iconNameAndStyling]="'delete.svg'"
                  (click)="formGroup.deleteMetric(i)">
                </app-all-icons>
                <app-all-icons
                  [attr.data-qa]="'kpi-cross-company-crud-modal-form-group-bundles-'+i+'-duplicate-metric'"
                  class="icon-size-1p5 pd-top-0p6"
                  [style.cursor]="'pointer'"
                  [iconNameAndStyling]="'copy-outline.svg'"
                  (click)="formGroup.duplicateMetric(i)">
                </app-all-icons>
              </div>
            </div>
          } @else {
            <div
              class="centered-column-container black-9 padding-top-bttm-3p75 column-gap-0p5"
              data-qa="kpi-cross-company-empty-state">
              <app-all-icons
                [iconNameAndStyling]="'empty-tray.svg; icon-size-3p125'"
              />
              <span class="title-3 bold600">No metrics yet</span>
            </div>
          }
        </div>
      </div>
      <div class="space-between-horizontal-centered">
        <app-button
          data-qa="kpi-cross-company-add-metric-button"
          [type]="'accent'"
          [size]="'medium'"
          [iconName]="'plus.svg'"
          (click)="formGroup.addMetric()">
          Metric
        </app-button>
        <div class="centered-row-container row-gap-0p5">
          <app-button
            data-qa="kpi-cross-company-cancel-button"
            [size]="'medium'"
            (click)="close(false)">
            Cancel
          </app-button>
          <app-button
            data-qa="kpi-cross-company-apply-button"
            [type]="'accent'"
            [size]="'medium'"
            (click)="update()">
            Apply
          </app-button>
        </div>
      </div>
    </div>
  </ng-container>

</app-modal-container>
